import get from "lodash/get";

import { bagCheckoutMVTPath } from "@template/state/middleware/infoBanner/validPath";

export const getBagCheckoutPromptMVTStatus = state =>
  bagCheckoutMVTPath() &&
  get(state, `features["emf-126-mweb-bag-checkout-prompt"]`);
